
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic13 as ObiHydraulic13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-13.js';
 
 
 

 
 export const ObiHydraulic13 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-13',
   elementClass: ObiHydraulic13Element,
   events: {
     
   }
  });
 
 